/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './ActionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

export const setSearchInput = (data) => {
  return {
    type: ActionTypes.SET_SELECTED_INPUT,
    payload: data,
  };
};

export const dispatchErrorMsgNDCDetail = (data) => ({
  type: ActionTypes.GET_ERROR_MSG_NDC_DETAILS,
  payload: data,
});

export const refreshDrugsTherapeuticClass = () => ({
  type: ActionTypes.REFRESH_DRUGS_THERAPEUTIC_CLASS,
  payload: {},
});
export const refreshDisplayDrugsTherapeuticClass = () => ({
  type: ActionTypes.REFRESH_DRUGS_THERAPEUTIC_CLASS_DISPLAY,
  payload: {},
});

// This action show error message for 5 sec for no contract exists
const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  //   dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

//API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};
//API for 1st screen Therapeutic class

export const dispatchDrugsTherapeuticClass = (data) => ({
  type: ActionTypes.DISPATCH_DRUGS_THERAPEUTIC_CLASS,
  payload: data,
});

//get drugs therapeutic class list
export const getDrugsTherapeuticClass = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_DRUGS_THERAPEUTIC_CLASS, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        dispatchDrugsTherapeuticClass(response?.data?.SPEC_THERA_CLASS_CD)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchDrugsTherapeuticClass([]));
    });
};

//Dispatch proccess API for matching the specific drug class name.
export const dispatchDrugsTherapeuticClassProccess = (data) => ({
  type: ActionTypes.DISPATCH_DRUGS_THERAPEUTIC_CLASS_PROCCESS,
  payload: data,
});

// API to get Therapeutic class proccess data
export const getDrugsTherapeuticClassProccess = (value) => (dispatch) => {
  dispatch(setLoading(true));
  dispatch(dispatchDrugsTherapeuticClassProccess([]));
  return axios
    .post(serviceEndPoint.GET_DRUGS_THERAPEUTIC_CLASS_PROCCESS, value)
    .then((response) => {
      dispatch(setLoading(false));
      if (response.data.drugTherapeuticProcessVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(
          dispatchDrugsTherapeuticClassProccess(
            response.data.drugTherapeuticProcessVO
          )
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchDrugsTherapeuticClassProccess([]));
    });
};

//Dispatch proccess API for matching the specific drug class name.
export const dispatchDrugsTherapeuticClassReport = (data) => ({
  type: ActionTypes.DISPATCH_DRUGS_THERAPEUTIC_CLASS_REPORT,
  payload: data,
});

// API to get Therapeutic class proccess data
export const getDrugsTherapeuticClassReport = (value) => (dispatch) => {
  dispatch(setLoading(true));
  dispatch(dispatchDrugsTherapeuticClassReport([]));
  return axios
    .post(serviceEndPoint.GET_DRUGS_THERAPEUTIC_CLASS_REPORT, value)
    .then((response) => {
      dispatch(setLoading(false));
      if (response.data.drugTherapeuticReportVO.length == 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(
          dispatchDrugsTherapeuticClassReport(
            response.data.drugTherapeuticReportVO
          )
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchDrugsTherapeuticClassReport([]));
    });
};
